import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Flex, Box } from '@rebass/grid';
import animate from 'app/helpers/animations/searchProgress';
import { isMobile } from 'app/helpers/utils';

import WithTitle from 'app/layouts/WithTitle';
import ProgressBar from 'app/ui_components/ProgressBar';
import { P } from 'app/ui_components/tags';
import OrangeHeadline from 'app/ui_components/OrangeHeadline';
import ResetButton from 'app/components/ResetButton';

class SearchProgress extends Component {
  static propTypes = {
    domain: PropTypes.string.isRequired,
    percentageComplete: PropTypes.number.isRequired,
    error: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.messages = [
      'Indexing the pages of your website.',
      'Searching for a menu section.',
      'Scanning your website’s reservation experience.',
      'Searching for an online store.',
      'Reviewing your website on mobile, desktop, and tablet devices.',
      'Searching for Private Events booking.',
      'Searching for Catering options and experience.',
      `Simulating a guest's browsing experience on your website.`,
      'Finalizing full scan now.',
    ];
  }

  // Someone (Product, Design, etc.) may want to extend the time it
  // takes to cycle through all of the messages
  extendMessageTemporalDuration = () => {
    const MULTIPLIER = 2;
    const extendedMessages = [];
    for (let i = 0; i < this.messages.length; i++) {
      for (let j = 0; j < Math.round(MULTIPLIER); j++) {
        extendedMessages.push(this.messages[i]);
      }
    }
    this.messages = extendedMessages;
  };

  componentWillMount() {
    this.extendMessageTemporalDuration();
  }

  componentDidMount() {
    animate();
  }

  render() {
    const { props: { domain, percentageComplete, error }, messages } = this;

    const copy = messages.length > 1 ? messages.shift() : messages[0];

    const title = (
      <React.Fragment>
        Cooking up your results<br />
        <small style={{ color: '#333', lineHeight: 1 }}>{copy}</small>
      </React.Fragment>
    );

    // If there is an error, display the error
    const subtitle = !error ? (
      <OrangeHeadline id="percentage">{percentageComplete}%</OrangeHeadline>
    ) : (
      error
    );

    /* Important Note */
    // We are setting the container width to 100% and the
    // progress bar width to 40% in order to avoid the `copy`
    // running onto 2 lines and changing the vertical position
    // of the progress bar.

    return (
      <WithTitle
        id="searchProgress"
        childrenInheritLayout
        title={title}
        subtitle={subtitle}
        width={!error ? [1 / 1] : [2 / 5]}
        mb={38}
        minTitleHeight={isMobile ? 175 : -1}
      >
        {!error ? (
          <Flex
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
          >
            <Box width={[4 / 5, 3 / 5, 2 / 5]} mb={15} mt={-13}>
              <ProgressBar
                progress={parseInt(percentageComplete)}
                id="progressBar"
              />
            </Box>
          </Flex>
        ) : (
          <Box width={[4 / 5, 3 / 5, 2 / 5]}>
            <ResetButton />
          </Box>
        )}
      </WithTitle>
    );
  }
}

const mapStateToProps = ({
  website: { domain },
  poll: { count, complete, error, timeout },
}) => {
  let percentageComplete = !complete
    ? parseInt((Math.atan(count * 2 / 3e3) / (Math.PI / 2) * 10000).toFixed(0))
    : 100;
  // cap at 100
  percentageComplete = percentageComplete > 100 ? 100 : percentageComplete;

  return {
    domain,
    percentageComplete,
    error,
  };
};

export default connect(mapStateToProps, null)(SearchProgress);
